<template>
    <div>
        <member-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter"
                            :setFilter="setFilter"></member-filter-link>
        <member-list-link :listLayout="listLayout" :paginationData="filterSet.page" :memberData="List"
                          :categorys="categorys"></member-list-link>
        <pagination-link :paginationLayout="paginationLayout" :type="'next'" :paginationData="filterSet.page"
                         :setPage="setPage" :listLength="List.length" :setData="setData"></pagination-link>
    </div>
</template>

<script>
import VuxAlert from "@/mixins/vux-alert"
import MemberFilterLink from "@/components/member/MemberFilterLink";
import MemberListLink from "@/components/member/MemberListLink";
import PaginationLink from "@/components/member/PaginationLink";
import memberUtil from "@/components/member/memberUtil";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import EventBus from "@/utils/event-bus";

const {filterConfig} = memberUtil;

export default {
    name: 'MemberListComponent',
    mixins: [VuxAlert, filterMixins, listMixins, memberUtil],
    components: {
        MemberFilterLink,
        MemberListLink,
        PaginationLink,
    },
    props: {
        memberType: {},
        cafeKey: {
            type: Number,
            default: () => {
                return 0
            }
        }
    },
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            setData: this.setData,
        }
    },
    data() {
        return {
            PageStart: true,
            getFunc: null,

            listLayout: '',
            filterLayout: '',
            paginationLayout: '',
            paginationType: '',
            listApiParamSet: {},
            isCategory: false,

            searchInput: '',
            searchInputOption: 'su',
            filterDate: ['', ''],
            categorys: [],
            isCafe: false
        }
    },
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
        if (this.isCategory) {
            this.getCategory();
        }
    },
    mounted() {
        this.getList(true);
    },
    computed: {},
    methods: {
        initConfig() {
            let memberConfig = this.returnMemberConfig(this.memberType);
            this.getFunc = memberConfig.getFunc;
            this.listLayout = memberConfig.listLayout;
            this.filterLayout = memberConfig.filterLayout;
            this.paginationLayout = memberConfig.paginationLayout;
            this.paginationType = memberConfig.paginationType;
            this.listApiParamSet = memberConfig.listApiParamSet;
            this.isCategory = memberConfig.isCategory;
            this.isCafe = memberConfig.isCafe;


            let pageRow = memberConfig.pageRow ? memberConfig.pageRow : 10;
            if (pageRow != this.filterSet.page.size) {
                this.filterSet.page.size = pageRow;
            }
            if (this.isCafe) {
                this.listApiParamSet.c_idx = this.cafeKey;
            }
            let listOptions = {
                url: this.$api.$member[this.getFunc],
                defaultParams: this.listApiParamSet,
            }
            this.initList('api', listOptions);
        },
        setData(key, value) {
            this[key] = value;
        },
        getCategory() {
            let params = {
                moc_type: 'admin'
            }
            try {
                this.$api.$member.getOutCategory(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type != 1) {
                        return false;
                    }
                    this.categorys = res.List;
                })
            } catch (e) {
                console.log(e);
            }
        },

    }
}
</script>
